import { Helmet } from 'react-helmet';

const Help = () => <>
    <Helmet>
        <title>
            Помощь
        </title>
    </Helmet>
    <h4>Если вы хотите получить ресурсы на свой проект, то:</h4>
    <ol>
        <li>Создайте проект</li>
        <li>Опишите про что проект</li>
        <li>Опишите что вам для него нужно в разделе &quot;Запросы&quot; справа</li>
        <li>Дождитесь ответов на запросы</li>
        <li>Получите ресурсы или помощь от тех кто запросил</li>
        <li>Подтвердите получение ресурсов или помощи</li>
    </ol>
    <h4>Если вы хотите помочь проекту, то:</h4>
    <ol>
        <li>Выберите проект</li>
        <li>Выберите запрос, на который вы готовы откликнуться в разделе &quot;Запросы&quot; справа</li>
        <li>Добавьте свой ответ на запрос</li>
        <li>Предоставьте ресурсы или окажите помощь</li>
        <li>Дождитесь подтверждения получения ресурсов или помощи</li>
    </ol>
</>;

export default Help;
